module.exports = ".btn-forgot-password{margin-left:0 !important;width:100%}\n"